import { render, staticRenderFns } from "./RootPresidentiView.vue?vue&type=template&id=50e1e314&"
import script from "./RootPresidentiView.vue?vue&type=script&lang=ts&"
export * from "./RootPresidentiView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports